import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import GemIcon from '../../components/Idle/GemIcon';
import { PRIZES } from '../../lib/idle/weekly';
import Styles from './Leaderboard.module.css';

const rangeLabel = (p) => (p.from === p.to ? `#${p.from}` : `#${p.from} – #${p.to}`);

const PrizesModal = ({ onClose }) => {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className={Styles.overlay} onMouseDown={onClose}>
      <div
        className={Styles.modal}
        role="dialog"
        aria-modal="true"
        aria-label="Weekly prizes"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <h2 className={Styles.modalTitle}>Weekly prizes</h2>
        <p className={Styles.modalSub}>
          The top 20 players each week win gems. They are paid out when the board resets.
        </p>
        <ul className={Styles.prizeList}>
          {PRIZES.map((p) => (
            <li key={p.from} className={Styles.prizeRow}>
              <span className={Styles.prizeRank}>{rangeLabel(p)}</span>
              <span className={Styles.prizeDots} />
              <span className={Styles.prizeGems}>
                <GemIcon size={22} /> {p.gems}
              </span>
            </li>
          ))}
        </ul>
        <button type="button" className={Styles.doneBtn} onClick={onClose} autoFocus>
          Got it
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default PrizesModal;